import InventoryItem from "../game/mechanics/InventoryItem";
import { InventoryItemContainerProps } from "../../pages/character/components/InventoryItemSlot/InventoryItemContainer";

type TransferableItemContainerProps = {};

type ItemTransferHandshakeParams = {
    incomingItem: InventoryItem | null;
    restrictor?: ((item: InventoryItem | null) => boolean) | null;
};

type ItemTransferParams = {
    item: InventoryItem | null;
    setItemCallback?: (item: InventoryItem | null) => void;
};

export const itemTransferHandshake: (
    ...args: ItemTransferHandshakeParams[]
) => boolean = (...args) => {
    return args.every((check) => {
        if (check.restrictor != null) {
            if (!check.restrictor(check.incomingItem)) {
                return false;
            }
        }

        return true;
    });
};

export const validateTransfer: (
    target1?: InventoryItemContainerProps | null,
    target2?: InventoryItemContainerProps | null
) => boolean = (target1, target2) => {
    if (target1 == null || target2 == null) {
        // Cannot transfer to or from a null target
        return false;
    }

    if (target1.id === target2.id) {
        // Cannot transfer from a target to itself
        return false;
    }

    return itemTransferHandshake(
        {
            incomingItem: target1.item,
            restrictor: target2.itemRestrictor,
        },
        { incomingItem: target2.item, restrictor: target1.itemRestrictor }
    );
};

export const executeTransfers: (args: {
    onComplete?: () => void;
    transfers: ItemTransferParams[];
}) => void = (args) => {
    for (var i = 0; i < args.transfers.length; ++i) {
        args.transfers[i].setItemCallback?.(args.transfers[i].item);
    }

    args.onComplete?.();
};
